const EXTRA_TYPES = {
  SITE_NIGHT_VOUCHER: 'SITE NIGHT VOUCHERS',
  MEMBERSHIP: 'MEMBERSHIP',
  OCCUPANCY: 'OCCUPANCY',
};

export default EXTRA_TYPES;
